
import { defineComponent } from 'vue';
import VBanner from '@/components/Banner.vue'

export default defineComponent({
  name: 'App',
  components: {
    VBanner,
  }
});
